import { createCustomEnum } from "./customEnum";

const FrontEndPlatformTypes = createCustomEnum({
	None: {
		value: 0,
		name: "None",
		displayName: "None",
	},
	Omaha: {
		value: 1,
		name: "Omaha",
		displayName: "Omaha",
	},
	Nashville: {
		value: 2,
		name: "Nashville",
		displayName: "Nashville",
	},
	North: {
		value: 3,
		name: "North",
		displayName: "North",
	},
	Compass: {
		value: 4,
		name: "Compass",
		displayName: "Compass",
	},
	BuyPass: {
		value: 5,
		name: "BuyPass",
		displayName: "BuyPass",
	},
	Other: {
		value: 6,
		name: "Other",
		displayName: "Other",
	},
});

export default FrontEndPlatformTypes;
